import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import useCurrentUser from '~/react-hooks/use-current-user';

import styled from '@emotion/styled';
import colours from '~/utils/colours';
import ContentBlockTab from '../../Components/Tabs/ContentBlock';
import EditorContext, { EditorContextProps } from './Context';
import DesignElements from '../../Components/Tabs/DesignElements';
import { MessageTemplateType } from '~/types/models';

const StlyedTabs = styled(Tabs)`
  ul.nav {
    display: flex;
    align-items: center;
    justify-content: center;

    li {
      &:first-child {
        margin-right: 20px;
      }
      a {
        padding: 0;
        font-family: Lato;
        font-size: 16px;
        line-height: 30px;
        font-weight: bold;
        color: ${colours.greyDark};
        border-bottom-size: 3px;
      }

      &.active {
        a,
        a:hover,
        a:focus {
          color: ${colours.greyDark};
        }
      }
    }

    @media (max-width: 1024px) {
      justify-content: space-between;
      li {
        margin-right: 0;
        a {
          font-size: 14px;
        }
      }
    }
  }
`;
const LandingPageDesign = () => {
  const user = useCurrentUser();
  const context: EditorContextProps = useContext(EditorContext);
  const { get } = context;

  const templateType = get('email_template.template_type');
  const [tabKey, setTabKey] = useState('content-blocks');

  const enableContetBlockTab =
    user.features.canAccessNextGenTemplate &&
    templateType === MessageTemplateType.NextGen;

  useEffect(() => {
    if (
      templateType === MessageTemplateType.Postcard ||
      !templateType ||
      !enableContetBlockTab
    ) {
      setTabKey('design-elements');
    } else {
      setTabKey('content-blocks');
    }
  }, [templateType]);

  return (
    <>
      <StlyedTabs
        id='landing-page-tab'
        activeKey={tabKey}
        onSelect={(k) => setTabKey(k)}
      >
        {enableContetBlockTab && (
          <Tab eventKey='content-blocks' title='Content Blocks'>
            <ContentBlockTab />
          </Tab>
        )}
        <Tab eventKey='design-elements' title='Design Elements'>
          <DesignElements />
        </Tab>
      </StlyedTabs>
    </>
  );
};

export default LandingPageDesign;
